import { useSelector } from 'react-redux';
import Alert from '@rsos/components/capstone/Queue/Alert';
import { Box, Text } from '@rsos/components/capstone/base';
import { getTheme } from '@rsos/theme/themes';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';

/**
 * @param {object} data - content data based on content type
 * @param {boolean} isAllView - allView or selected incident mode
 * @returns Google Maps info window content
 */
const AlertInfoWindowContent = ({ data = {}, isAllView = false }) => {
  const userProfile = useSelector(state => state.sinatra.user.profile);
  const theme = getTheme('light');
  const alert = data?.alert;
  const isTrainAlertOrTest =
    `${alert?.emergency_type?.name}`.includes('TRAIN') ||
    `${alert?.emergency_type?.name}`.startsWith('TEST');
  const popupTitle = isTrainAlertOrTest
    ? alert?.emergency_type?.display_name
    : `${alert?.site_type?.display_name} ${alert?.emergency_type?.display_name}`;
  const createdAt = data?.created_at;
  if (isAllView) {
    return (
      <Alert
        alert={alert}
        isMapMarker={true}
        userProfile={userProfile}
        theme={theme}
      />
    );
  } else {
    return (
      <Box padding="4px 8px">
        <Text pb="4px">{popupTitle}</Text>
        <Text size="small" pb="4px">
          {convertUnixTimestamp(createdAt, true)}
        </Text>
        <Text size="small" color="secondaryText">
          Source: {alert.service_provider_name}
        </Text>
      </Box>
    );
  }
};

export default AlertInfoWindowContent;
